import * as React from "react";
import { styled } from "@mui/system";
import MUITypography, { TypographyProps } from "@mui/material/Typography";

declare module "@mui/material/Typography" {
  interface TypographyPropsVariantOverrides {
    titleSmall: true;
    pageDescription: true;
    titleMedium: true;
    titleXSmall: true;
    titleLarge: true;
    body: true;
    captionSmall: true;
    caption: true;
    display: true;
    eyebrow: true;
    heading: true;
    label: true;
    boldLabel: true;
    labelDisabled: true;
    formLabelDisabled: true;
    filedText: true;
    leadXLarge: true;
    leadLarge: true;
    leadMedium: true;
    leadSmall: true;
    displayLarge: true;
    displayMedium: true;
    displaySmall: true;
    subtitle: true;
    body500: true;
    body700: true;
    bodySmall500: true;
    bodySmall700: true;
    bodyLarge: true;
    bodyLarge500: true;
    bodyLarge700: true;
    buttonLarge: true;
    button: true;
    codeInput: true;
  }
}

export const Typography = styled(
  (props: TypographyProps) => <MUITypography {...props} />,
  {
    name: "Typography",
    slot: "Root",
    overridesResolver: (props, styles) => [],
  }
)(({ theme }) => ({}));
